export const Documents = "documents";

export enum DocumentsRoutes {
    Edit = "edit",
}
